import { call, takeEvery, takeLatest, delay, all, put } from 'redux-saga/effects'
import { savedItemmap, fetchedItemmap, storeSearchItemmapResult, deletedItemmap } from './actions'
import axios from 'axios';
import { handlError, parseError } from '../../app/serverError'
import { URL, getHeaderJWT } from '../../../store/path'
import userACL from '../../../store/access'
import { merge } from 'lodash'

// const delay = (ms) => new Promise(res => setTimeout(res, ms))

//#region Saga for Create Itemmap 

function* createItemmap() {
  yield takeEvery('CREATE_ITEMMAP', saveItemmap)
}

function* saveItemmap(action) {
  const { response, error } = yield call(saveItemmapAPI, action.payload)
  if (response) {
    if (response.data.type && response.data.type === "error") {
      yield put(savedItemmap(action.payload, "error", response.data.data || response.data.msg || 'Operation failed.'))
    } else {
      yield put(savedItemmap(action.payload, "success", response.data.msg || response.data.data || 'Saved successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function saveItemmapAPI(data) {
  try {
    const response = await axios.post(URL + '/master/itemmap/add', data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Edited Itemmap 

function* editItemmap() {
  yield takeEvery('EDIT_ITEMMAP', saveEditedItemmap)
}

function* saveEditedItemmap(action) {
  const { response, error } = yield call(editItemmapAPI, action.payload)
  if (response) {
    if (response.data.type && response.data.type === "error") {
      yield put(savedItemmap(action.payload, "error", response.data.data || response.data.msg || 'Operation failed.'))
    } else {
      yield put(savedItemmap(action.payload, "success", response.data.msg || response.data.data || 'Saved successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function editItemmapAPI(data) {
  let userid = data.id
  try {
    const response = await axios.post(URL + '/master/itemmap/update/' + userid, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Delete Itemmap 

function* deleteItemmap() {
  yield takeEvery('DELETE_ITEMMAP', saveDeleteItemmap)
}

function* saveDeleteItemmap(action) {
  const { response, error } = yield call(deleteItemmapAPI, action.payload)
  if (response) yield put(deletedItemmap({ id: action.payload.id, msg: response.data }))
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function deleteItemmapAPI(data) {
  let itemmapId = data.id
  try {
    const response = await axios.post(URL + '/itemmap/delete/' + itemmapId, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for List Itemmap 

function* fetchItemmap() {
  yield takeEvery('FETCH_ITEMMAP', requestItemmap)
}


function* requestItemmap() {
  let { data } = yield call(requestItemmapAPI)
  yield put(fetchedItemmap(data))
}


function requestItemmapAPI(data) {
  data = merge({}, data, userACL.atFetch())
  return axios.post(URL + '/master/itemmap/list', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


//#region Saga for Search Itemmap 

function* searchItemmap() {

  yield takeLatest('SEARCH_ITEMMAP', initiateSearch)

}

function* initiateSearch(action) {
  yield delay(350)
  let { data } = yield call(searchAPI, action.payload)
  yield put(storeSearchItemmapResult(data))

}

function searchAPI(data) {
  return axios.post(URL + '/itemmap/search/' + data, data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* itemmapSaga() {
  yield all([
    createItemmap(),
    fetchItemmap(),
    editItemmap(),
    deleteItemmap(),
    searchItemmap()
  ])
}  